import type { GeneratedSchemaKind } from '@cli-types/core-engine/add-field.js'
import { ENTITY_SINGLE_ADD_FIELD_TYPES, FORM_ADD_FIELD_TYPES } from '@cli-constants/schema.js'

export function isSupportedAddFieldType(kind: GeneratedSchemaKind, type: string): boolean {
  return kind === 'form'
    ? (FORM_ADD_FIELD_TYPES as readonly string[]).includes(type)
    : (ENTITY_SINGLE_ADD_FIELD_TYPES as readonly string[]).includes(type)
}
